<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('notification')">Notification</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create 
    </h1>
    <preview :preview_message=form.message />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input v-model="form.message" class="pr-6 pb-8 w-full" label="Notification" rows="4" max-rows="6" :error="this.$page.props.errors.message"/>
          <text-input v-model="form.wait_time" class="pr-6 pb-8 lg:w-1/" label="Wait time (in min)" :error="this.$page.props.errors.wait_time"/>
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Notification</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '../../Shared/TextareaInput.vue'
import Preview from '../../Shared/Preview.vue'

export default {
  metaInfo: { title: 'Create Notification' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Preview,
  },
  layout: Layout,
  remember: 'form',

  data() {
    return {
      form: this.$inertia.form({
        message: null,
        wait_time: null,
        is_enabled: 1,
      })
     };
  },
  methods: {
    store() {
      this.form.post(this.route('notification.store'))
    },
    update() {
      this.form.put(this.route('notification.update', this.notification.id))
    },
  },
}
</script>
